import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IRessource } from '../models/ressource';
import { RessourceService } from '../services/ressource.service';

@Injectable({
  providedIn: 'root'
})
export class RessourceResolver  {

  constructor(
    private ressourceService : RessourceService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IRessource[]> {
    return this.ressourceService.searchRessources({pageNumber: 0, pageSize: 999999})
    .pipe(
      map(response => response.data)
    )
  }
}
